module.exports = __webpack_public_path__ + "img/out-step2-1.daf08f47.png";